<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.detail.title') }}
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.detail.title') }} </span>
                </div>
                <div class="" v-if="!item.name">
                    Numele este obliatoriu pentru a publica unitatea dvs.
                </div>
                <div class="" v-if="!item.static.defaults.certificate">
                    Certificarea unitatii dvs va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!item.static.defaults.stars">
                    Numarul de stele va pot aduce aduce mai multe rezervari
                </div>
                <div class="" v-if="!(item.description.ro && (item.description.ro.length>199))">
                    O descriere mai ampla a unitatii dvs va poate aduce mai multe rezervari
                </div>
                <div class="" v-else>
                    Descrierea unitatii dvs este necesara pentru a informa turistii
                </div>
                <div class="" v-if="!item.description.en">
                    O descriere intr-o limba internationala va poate aduce mai multe rezervari
                </div>
            </div>
        </v-tooltip>
        <v-icon class="pa-1 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon>
    </v-card-title>
    <v-card-text>
        <div class="px-1">{{item.name}}</div>
        <v-rating v-if="clasification" class="pa-0" v-model="hotel_stars" :length="hotel_stars" readonly>
            <template v-slot:item="props">
                <v-icon class="pa-0" color="yellow">star</v-icon>
            </template>
        </v-rating>
        <div v-if="clasification" class="pa-1"><span>{{ $t('hotel.card.detail.clasification') }} </span>{{item.static.defaults.certificate}}</div>
        <div class="pa-1 text-capitalize">{{ $t('hotel.card.detail.context') }} {{item.context}}</div>
        <div v-if="item.description.ro" class="pa-1">
            {{ textMoreLess() }}
            <span v-if="text_more_less" @click="show_more = !show_more" style="color: blue;cursor: pointer">
                <span v-if="show_more">{{ $t('hotel.less') }}</span>
                <span v-if="!show_more">{{ $t('hotel.more') }}</span>
            </span>
        </div>
    </v-card-text>
    <!--info dialog-->
    <v-dialog v-model="status_dialog" max-width="720">
        <v-card>
            <v-card-title class="hotel-card-title" primary-title>
                Info
            </v-card-title>
            <v-card-text class="info-text">
                <div class="" v-if="!item.name">
                    Numele este obliatoriu pentru a publica unitatea dvs.
                </div>
                <div class="" v-if="!item.static.defaults.certificate">
                    Certificarea unitatii dvs va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!item.static.defaults.stars">
                    Numarul de stele va pot aduce aduce mai multe rezervari
                </div>
                <div class="" v-if="!(item.description.ro && (item.description.ro.length>199))">
                    O descriere mai ampla a unitatii dvs va poate aduce mai multe rezervari
                </div>
                <div class="" v-else>
                    Descrierea unitatii dvs este necesara pentru a informa turistii
                </div>
                <div class="" v-if="!item.description.en">
                    O descriere intr-o limba internationala va poate aduce mai multe rezervari
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="status_dialog=false">
                    {{ $t('button.exit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./info dialog -->
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object
    },
    name: `hotel-details`,
    components: {},
    data() {
        return {
            status_dialog: false,
            color: 'grey',
            hover: false,
            stars: [],
            text_more_less: false,
            show_more: false,
            clasification: (this.item.static.defaults.stars > 0 && this.item.static.defaults.certificate_status == "active"),
        };
    },

    watch: {
        item: {
            handler() {
                this.item.static.defaults.stars = Number(this.item.static.defaults.stars);
                if(this.item.static.defaults.stars > 0 && this.item.static.defaults.certificate_status == "active") {
                    this.clasification = true
                } else {
                    this.clasification = false
                }
                this.checkChain();
            }
        },
        clasification: {
            handler() {
                if(this.clasification) {
                    this.item.static.defaults.certificate_status = "active"
                } else {
                    this.item.static.defaults.certificate_status = "not-certified"
                }
            }
        }
    },

    mounted() {
        this.item.static.defaults.stars = Number(this.item.static.defaults.stars);
    },

    computed: {
        hotel_stars() {
            if(Number(this.item.static.defaults.stars)) {
                return Number(this.item.static.defaults.stars)
            } else {
                return 0
            }
        },
        procent_status() {
            let procent = 0;
            if(this.item.name) {
                procent += 50;
            }
            if(this.item.static.defaults.certificate) {
                procent += 10;
            }
            if(this.item.static.defaults.stars) {
                procent += 15;
            }
            if(this.item.description.ro) {
                if(this.item.description.ro.length > 199) {
                    procent += 15;
                } else {
                    procent += 10;
                }
            }
            if(this.item.description.en) {
                procent += 10;
            }

            this.setColor(procent);
            return procent;
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        checkChain() {
            switch (this.item.static.defaults.chain) {
            case null:
                this.chain = false;
                break;
            case undefined:
                this.chain = false;
                break;
            case '':
                this.chain = false;
                break;
            default:
                this.chain = true;
            }
        },

        textMoreLess() {
            if(this.item.description.ro.length > 99) {
                this.text_more_less = true;
                if(!this.show_more) {
                    return this.item.description.ro.substr(0, 100) + " ... "
                } else {
                    return this.item.description.ro
                }
            } else {
                this.text_more_less = false;
                return this.item.description.ro
            }
        },

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }
    },
};
</script>

<style lang="stylus">
.weekend-days .v-btn
    min-width: 55px
.description-warning
    &.v-input
        .v-text-field__details
            .v-messages
                .v-messages__message
                    color: orangered
.hotel-card-title
    font-size: 18px
    font-weight: 500
    line-height: 1.2
    color: #475F7B
</style>
